import { createAction } from 'redux-actions';
import types from './types';

export const setSubscriptionsDetails = createAction(types.SET_SUBSCRIPTIONS_DETAILS);
export const increaseUsedDiscountsCounter = createAction(types.INCREASE_USED_DISCOUNTS_COUNTER);
